/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Return_Defect_ExceedsInputs */

const vi_error_return_defect_exceeds = /** @type {(inputs: Error_Return_Defect_ExceedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số hàng lỗi của một lô không được lớn hơn số trả của lô đó.`)
};

/**

* @param {Error_Return_Defect_ExceedsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_return_defect_exceeds = /** @type {((inputs?: Error_Return_Defect_ExceedsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Return_Defect_ExceedsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_return_defect_exceeds(inputs)
});